export default __webpack_public_path__ + "static/media/integration.8a959b4d.png";